export default __webpack_public_path__ + "25f51b7.png";